import React, { useEffect, useState } from "react";
import AccessController from "_shared/AccessController";
import { DashGridL2 } from "layouts/dash-grid";
import TopBar from "_shared/Top";
import { Toaster } from "react-hot-toast";
import DealerDirectoryList from "./DealerDirectoryList";
import DealerDetail from "./DealerDetail";

const Main = () => {
  const [showDealer, setShowDealer] = useState(false);
  const [selectedDealer, setSelectedDealer] = useState(null);
  let data = {};

  const closeDealerDetail = () => {
    setSelectedDealer(null);
  };

  console.log("datad", selectedDealer);
  return (
    <>
      {selectedDealer ? (
        <DealerDetail data={selectedDealer} onClose={closeDealerDetail} />
      ) : (
        <DealerDirectoryList onSelectDealer={setSelectedDealer} />
      )}
      {/* <DealerDirectoryList />
      <DealerDetail /> */}
    </>
  );
};

const DealerDirectory = () => {
  return (
    <AccessController roles={["AO", "RO", "ZO", "ADMIN"]}>
      <DashGridL2 Top={TopBar} Main={Main} />
      <Toaster />
    </AccessController>
  );
};

export default DealerDirectory;
